/**
 * Mobildeki sabit satin alma cubugu.
 *
 * Sayfadaki gercek "Sepete ekle" butonuna vekalet eder: metnini, devre disi
 * durumunu ve tiklamayi ondan alir. Cerceve ve paket modullerinin kendi
 * butonu varsa (secimler bitene kadar devre disi kalan buton) onu kullanir;
 * temanin butonu bu moduller tarafindan gizlendigi icin ona dokunmaz.
 * Gercek buton ekrana girdiginde cubuk gizlenir, boylece ayni eylem iki kez
 * gorunmez.
 */
class ProductStickyBar extends HTMLElement {
  connectedCallback() {
    this.priceEl = this.querySelector('[data-sticky-price]');
    this.buttonEl = this.querySelector('[data-sticky-button]');
    this.onClick = () => {
      const source = this.sourceButton();
      if (!source || source.disabled) return;
      source.click();
    };
    this.buttonEl.addEventListener('click', this.onClick);

    this.sync = this.sync.bind(this);
    // Cubuk kendi metnini ve sinifini guncelliyor. Bunlari da dinlersek
    // her guncelleme yeniden sync tetikler ve urun sayfasi kilitlenir.
    this.observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => !this.contains(mutation.target))) this.sync();
    });
    const product = this.closest('product-info') || document;
    this.observer.observe(product, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['hidden', 'disabled', 'class', 'aria-disabled'],
    });

    this.visibility = new IntersectionObserver(
      (entries) => {
        this.sourceInView = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio > 0.5);
        this.sync();
      },
      { threshold: [0, 0.5, 1] }
    );

    this.sync();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.visibility?.disconnect();
    this.buttonEl?.removeEventListener('click', this.onClick);
  }

  productRoot() {
    return this.closest('product-info') || document;
  }

  sourceButton() {
    const root = this.productRoot();
    const buttons = Array.from(
      root.querySelectorAll('.kms-add-to-cart, .qd-add-to-cart, .product-form__submit')
    );
    // Paket ve cerceve modulleri temanin butonunu gizleyip kendi butonlarini
    // aciyor. O an ekranda olan buton esas alinir.
    return buttons.find((el) => this.isVisible(el)) || buttons[0] || null;
  }

  priceText() {
    const price = this.productRoot().querySelector('.product__info-container .price');
    if (!price) return '';
    const sale = price.querySelector('.price__sale .price-item--sale, .price-item--sale');
    const regular = price.querySelector('.price-item--regular');
    const node = sale || regular;
    return (node ? node.textContent : price.innerText).replace(/\s+/g, ' ').trim();
  }

  isVisible(el) {
    if (!el || el.hidden) return false;
    const style = getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  sync() {
    const source = this.sourceButton();
    if (!source) {
      this.classList.add('is-hidden');
      return;
    }

    if (this.watched !== source) {
      this.visibility.disconnect();
      this.visibility.observe(source);
      this.watched = source;
    }

    const text = source.textContent.replace(/\s+/g, ' ').trim();
    if (text && this.buttonEl.textContent !== text) this.buttonEl.textContent = text;
    const disabled =
      !this.isVisible(source) || source.disabled || source.getAttribute('aria-disabled') === 'true';
    if (this.buttonEl.disabled !== disabled) this.buttonEl.disabled = disabled;
    const price = this.priceText();
    if (this.priceEl.textContent !== price) this.priceEl.textContent = price;

    const sourceOnScreen = this.isVisible(source) && this.sourceInView;
    this.classList.toggle('is-hidden', sourceOnScreen);
  }
}

if (!customElements.get('product-sticky-bar')) {
  customElements.define('product-sticky-bar', ProductStickyBar);
}
